export default __webpack_public_path__ + "static/media/logo-text.d08a2b7a.svg";